import { Badge, type BadgeProps } from '../ui/badge'
import type { ReactElement } from 'react'
import { DynamicIcon } from '../ui/DynamicIcon'
import { getFulfillmentTypeByValue } from '@/lib/fulfillment-type'
import { getFulfillmentPresentation } from './FulfillmentSurface'

function FulfillmentTypeBadge(
  props: Pick<BadgeProps, 'size' | 'onClick'> & { fulfillmentType?: string | null }
): ReactElement | null {
  const { fulfillmentType, size = 'md', onClick = undefined } = props

  const fulfillmentStatus = getFulfillmentTypeByValue(fulfillmentType)

  if (!fulfillmentStatus) {
    return null
  }

  const { badgeVariant } = getFulfillmentPresentation(fulfillmentType)

  return (
    <Badge variant={badgeVariant} size={size} onClick={onClick}>
      <DynamicIcon
        iconName={fulfillmentStatus.Icon}
        className={size === 'sm' ? 'size-3' : 'size-4'}
      />
      {fulfillmentStatus.Name}
    </Badge>
  )
}

export default FulfillmentTypeBadge
